module.exports = __webpack_public_path__ + "img/subscribeInPakage.32052b1f.svg";